import styled, { css, DefaultTheme } from "styled-components";
import { ColorsItemCountTasks } from "../../interface";

interface PropsItemHeader {
  currentStep: boolean;
}

export const Container = styled.div``;

export const Content = styled.div`
  box-shadow: 0px 1px 2px 2px rgba(0, 0, 0, 0.1);
  padding-bottom: 1rem;

  @media (min-width: 768px) {
    height: calc(100vh - 280px);
    overflow-y: auto;
  }
`;

export const Header = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  margin-top: 1.5rem;
  position: relative;
  z-index: 0;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  background-color: ${({ theme }) => theme.colors.orange};

  @media (min-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const ItemHeader = styled.button<PropsItemHeader>`
  position: relative;
  display: flex;
  justify-content: center;
  padding: 0.75rem 0.5rem 1.75rem;
  color: ${({ theme }) => theme.colors.white};
  font-size: 1rem;
  border: 0;
  background-color: transparent;

  &:after {
    position: absolute;
    top: 32px;
    left: 47%;
    content: "";
    width: 0;
    height: 0;
    border-bottom: 8px solid ${({ theme }) => theme.colors.white};
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    display: ${({ currentStep }) => (currentStep ? "block" : "none")};

    @media (min-width: 768px) {
      top: 35px;

      &:after {
        left: 40%;
      }
    }
  }

  @media (min-width: 768px) {
    padding: 0.75rem 0.5rem 1.5rem;
  }
`;

export const ResumeTasks = styled.div`
  padding: 1rem;
`;

export const WrapperTasks = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: 768px) {
    flex-direction: row;
  }
`;

export const ContentTasks = styled.div`
  box-shadow: 0px 1px 2px 2px rgba(0, 0, 0, 0.1);
  padding: 1rem;
  width: 100%;
  border-radius: 6px;

  @media (min-width: 768px) {
    max-width: 380px;
  }
`;

export const TitleResumeTasks = styled.span`
  ${({ theme }) => css`
    font-size: 1.25rem;
    color: ${theme.colors.black};
  `}

  @media (min-width: 768px) {
    font-size: 1.25rem;
  }
`;

export const CountTasks = styled.div`
  display: flex;
  margin-top: 1rem;
`;

const ItemCountTasksModifiers = {
  color: (theme: DefaultTheme, color: ColorsItemCountTasks["color"]) => css`
    color: ${theme.colors[color] || "black"};
  `,
};

export const ItemCountTasks = styled.div<ColorsItemCountTasks>`
  ${({ theme, color }) => css`
    font-size: 1.25rem;

    span {
      font-size: 1rem;
    }

    p {
      font-size: 1.5rem;
      margin: 0;
    }

    & + div {
      margin-left: 2rem;
    }

    ${!!color && ItemCountTasksModifiers.color(theme, color)};

    @media (min-width: 768px) {
      font-size: 1.25rem;
    }
  `}
`;

export const ViewPendingTasks = styled.button`
  ${({ theme }) => css`
    margin-top: 1.5rem;
    padding-top: 1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: ${theme.colors.black};
    border-top: 1px solid ${theme.colors.ultraLightGray};
    background-color: transparent;
    border: 0;
    width: 100%;

    svg {
      color: ${theme.colors.primary};
    }
  `}
`;

export const LastFinishedTask = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 1rem;

  @media (min-width: 768px) {
    padding-left: 1rem;
  }
`;

export const TitleLastFinishedTasks = styled.p`
  ${({ theme }) => css`
    font-size: 0.75rem;
    color: ${theme.colors.primary};
    margin: 0 1rem 1rem 1rem;
    text-transform: uppercase;

    @media (min-width: 768px) {
      font-size: 1rem;
    }
  `}
`;

export const ItemLastTask = styled.button`
  ${({ theme }) => css`
    display: flex;
    padding: 0 0.5rem 0.5rem;
    border: 0;
    border-bottom: 1px solid ${theme.colors.ultraLightGray};
    background: transparent;

    img {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      margin-right: 0.5rem;
    }

    > div {
      display: flex;
      flex-direction: column;

      p {
        text-align: left;
        color: ${theme.colors.gray};
        font-weight: bold;
        font-size: 0.875rem;
        margin: 0;
      }

      span {
        font-size: 0.75rem;
        color: ${theme.colors.gray};
      }
    }

    & + button {
      margin-top: 1rem;
    }

    @media (min-width: 768px) {
      img {
        width: 50px;
        height: 50px;
      }

      > div {
        p {
          font-size: 1rem;
        }

        span {
          font-size: 0.875rem;
        }
      }
    }
  `}
`;

export const ListCards = styled.div`
  padding: 1rem;
  display: grid;
  grid-template-columns: 1fr;
  row-gap: 2rem;

  @media (min-width: 768px) {
    grid-template-columns: repeat(auto-fill, minmax(20rem, 3fr));
    gap: 2rem;
  }
`;

export const WithoutTasks = styled.span`
  ${({ theme }) => css`
    font-size: 1rem;
    color: ${theme.colors.primary};
  `}
`;
